function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { array } from 'vega-util';
import { isConditionalDef, isConditionalParameter } from '../../../channeldef';
import { expression } from '../../predicate';
import { parseSelectionPredicate } from '../../selection/parse';
/**
 * Return a VgEncodeEntry that includes a Vega production rule for a scale channel's encoding or guide encoding, which includes:
 * (1) the conditional rules (if provided as part of channelDef)
 * (2) invalidValueRef for handling invalid values (if provided as a parameter of this method)
 * (3) main reference for the encoded data.
 */
export function wrapCondition(_ref) {
  var model = _ref.model,
    channelDef = _ref.channelDef,
    vgChannel = _ref.vgChannel,
    invalidValueRef = _ref.invalidValueRef,
    mainRefFn = _ref.mainRefFn;
  var condition = isConditionalDef(channelDef) && channelDef.condition;
  var valueRefs = [];
  if (condition) {
    var conditions = array(condition);
    valueRefs = conditions.map(function (c) {
      var conditionValueRef = mainRefFn(c);
      if (isConditionalParameter(c)) {
        var param = c.param,
          empty = c.empty;
        var test = parseSelectionPredicate(model, {
          param: param,
          empty: empty
        });
        return _objectSpread({
          test: test
        }, conditionValueRef);
      } else {
        var _test = expression(model, c.test); // FIXME: remove casting once TS is no longer dumb about it
        return _objectSpread({
          test: _test
        }, conditionValueRef);
      }
    });
  }
  if (invalidValueRef !== undefined) {
    valueRefs.push(invalidValueRef);
  }
  var mainValueRef = mainRefFn(channelDef);
  if (mainValueRef !== undefined) {
    valueRefs.push(mainValueRef);
  }
  if (valueRefs.length > 1 || valueRefs.length === 1 && Boolean(valueRefs[0].test) // We must use array form valueRefs if test exists, otherwise Vega won't execute the test.
  ) {
    return _defineProperty({}, vgChannel, valueRefs);
  } else if (valueRefs.length === 1) {
    return _defineProperty({}, vgChannel, valueRefs[0]);
  }
  return {};
}